(function () {
  let CartPickupSelect = class CartPickupSelect {
    constructor() {
      this.datepicker = document.getElementById("pick-up-date");
      this.pickupTimeSelect = document.getElementById("pick-up-time");
      if (!this.datepicker) {
        return;
      }
      this.datepickerError = document.getElementById("pick-up-date-error");
      this.checkoutButton = document.querySelector('.checkout__button');
      this.pickupTimeContainer = document.querySelector('.pick-up-time__container');
      this.previousPickupTimeValue = "";
      this.datepicker.addEventListener("change", this.dateOnChange.bind(this));
      

      document.addEventListener('theme:cart:change', (event) => {
        setTimeout(() => {
          this.dateOnChange(null);
        }, 500);
      });
    }

    dateOnChange(event) {
      const selectedDate = dayjs(this.datepicker.value);
      const isSpecial = Boolean(this.datepicker.options[this.datepicker.selectedIndex].dataset.special);
      const isEmpty = Boolean(this.datepicker.options[this.datepicker.selectedIndex].dataset.empty);

      // non special days are being checked against a day of the week
      // special days are being checked against the precise date      
      const dayToCheck = isSpecial? selectedDate.format('YYYY-MM-DD') : selectedDate.format('dd');

      this.showPickupTime();
      if(isSpecial) {
        this.hidePickupTime();
      }
      
      const cartItems = document.querySelectorAll("[data-cart-item]");
      this.datepickerError.style.display = "none";
      this.checkoutButton.disabled = false;

      // loop through cart items and check for availability 
      cartItems.forEach((cartItem) => {
        cartItem.querySelector('.cart__items__title').style.color = "";
        
        const cartItemAvailableOn = cartItem.dataset.availableon
          ? cartItem.dataset.availableon.split(",")
          : [];

        if (cartItemAvailableOn.length) {
          if (!cartItemAvailableOn.includes(dayToCheck)) {
            if(!isEmpty) {
              cartItem.querySelector('.cart__items__title').style.color = "var(--COLOR-PRIMARY)";
              this.datepickerError.style.display = "block";
            }
            this.checkoutButton.disabled = true;
          }
        }
      });
    }

    hidePickupTime() {
      this.previousPickupTimeValue = this.pickupTimeSelect.value;

      this.pickupTimeContainer.style.display = "none";
      this.pickupTimeSelect.value = "";
      
    }

    showPickupTime() {
      if(this.pickupTimeContainer.style.display == "block") {
        return;
      }
      
      this.pickupTimeContainer.style.display = "block";
      if(this.previousPickupTimeValue != "") {
        this.pickupTimeSelect.value = this.previousPickupTimeValue;
      }
    }
  };

  document.addEventListener("DOMContentLoaded", function () {
    new CartPickupSelect();
  });
})();
